import React, { Component } from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import selectionLayers from '../fixtures/selectionLayers';
import ValueSquare from './valueSquare';
import style from './selectionBlock.css';

class SelectionBlock extends Component {

  constructor(props) {
    super(props);
  }
  render() {
    return (
      <div
        className={(() => {
          const w = this.props.screenWidth;
          const maxColumns = selectionLayers[this.props.displayLayer].maxColumns;
          // const h = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);

          if (w > 700 && maxColumns > 5) {
            return style.centeredDynamicBlock;
          } else if (w > 600 && maxColumns > 4) {
            return style.centeredFiveBlock;
          } else if (w > 520 && maxColumns > 3) {
            return style.centeredFourBlock;
          } else if (w > 400 && maxColumns > 2) {
            return style.centeredThreeBlock;
          } else if (w > 280 && maxColumns > 1) {
            return style.centeredTwoBlock;
          }
          return style.centeredOneBlock;
        })()}
      >
        <div className={style.wordColumnBlock}>
          { (() => {
            const numSelected = _.reduce(this.props.valuesObject, (accumulator, obj) => accumulator + (obj.layer > this.props.displayLayer ? 1 : 0), 0);
            const isMoreToSelect = numSelected < selectionLayers[this.props.displayLayer + 1].size;
            return _.map(
              this.props.randomIdList,
              randId =>
                (this.props.valuesObject[randId].layer < this.props.displayLayer ?
                  ''
                  :
                  <ValueSquare
                    key={this.props.valuesObject[randId].id}
                    valueId={this.props.valuesObject[randId].id}
                    canSelect={isMoreToSelect}
                    isSelected={this.props.valuesObject[randId].layer > this.props.displayLayer}
                    displayTitle={this.props.valuesObject[randId].word}
                  />));
          })()
          }
        </div>
      </div>
    );
  }
}

// This is totally optional, but forces react to check the prop types
// when running in debug
SelectionBlock.propTypes = {
  screenWidth: PropTypes.number.isRequired,
  displayLayer: PropTypes.number.isRequired,
  valuesObject: PropTypes.object.isRequired,
  randomIdList: PropTypes.array.isRequired,
};


function mapStateToProps(state, props) {
  // console.log(state.valueSet);
  return {
    valuesObject: state.valueSet.values,
    randomIdList: state.valueSet.randomizedIds,
  };
}
function mapDispatchToProps(dispatch) {
  return {

  };
}
export default connect(mapStateToProps, mapDispatchToProps)(SelectionBlock);



// WEBPACK FOOTER //
// ./src/components/selectionBlock.js